<script lang="ts">
    import Btn from "../../components/Btn.svelte";
    import ButtonRow from "../../components/ButtonRow.svelte";
    import Container from "../../components/Container.svelte";
    import ContentBox from "../../components/ContentBox.svelte";
    import Divider from "../../components/Divider.svelte";
    import Dropdown from "../../components/Dropdown.svelte";
    import Gap from "../../components/Gap.svelte";
    import Headline from "../../components/Headline.svelte";
    import Hero from "../../components/Hero.svelte";
    import IconImg from "../../components/IconImg.svelte";
    import Image from "../../components/Image.svelte";
    import LightTheme from "../../components/LightTheme.svelte";
    import PagePreviews from "../../components/PagePreviews.svelte";
    import PageTransition from "../../components/PageTransition.svelte";
    import Row from "../../components/Row.svelte";
    import Subline from "../../components/Subline.svelte";
    import AlarmIcon from "../../icons/AlarmIcon.svelte";
    import Alarm from "../../icons/AlarmIcon.svelte";
    import KrankenwagenIcon from "../../icons/KrankenwagenIcon.svelte";
    import Krankenwagen from "../../icons/KrankenwagenIcon.svelte";
    import PhoneIcon from "../../icons/PhoneIcon.svelte";
    import Systeme from "../../icons/SystemsIcon.svelte";
    import ProjectPreviews from "../../components/ProjectPreviews.svelte";

    import type { Project } from "../../components/ProjectPreviews.svelte";
    import { ProjectCateories } from "../../components/ProjectPreviews.svelte";
    import { t } from "../../helpers/translation";

    const loadData = async (): Promise<Project[]> => {
        const data: Project[] = await fetch("/api/projects")
            .then((data) => data.json())
            .then((data) => {
                data.forEach((event) => {
                    if (event.startdate && event.enddate)
                        event.date =
                            new Date(event.startdate).toLocaleDateString() +
                            " - " +
                            new Date(event.enddate).toLocaleDateString();
                    else if (event.startdate)
                        event.date = new Date(
                            event.startdate,
                        ).toLocaleDateString();
                    else if (event.enddate)
                        event.date = new Date(
                            event.enddate,
                        ).toLocaleDateString();
                    else event.date = "";
                });
                data = data.filter(
                    (proj) =>
                        proj.projectcategoryid == ProjectCateories.ALARMIERUNG,
                );
                return data;
            });

        return data ? Promise.resolve<Project[]>(data) : Promise.reject(null);
    };
</script>

<!-- <LightTheme /> -->

<Hero
    headline={$t("page.digitalalarm.hero.headline")}
    small
    vid="https://liveicom.azureedge.net/sinus/vid/sinus_digitale_alarmierung.mp4"
/>

<Container>
    <Headline>
        {@html $t("page.digitalalarm.headline")}
    </Headline>
    <Subline>
        {@html $t("page.digitalalarm.subline")}
    </Subline>
    <p>
        {@html $t("page.digitalalarm.p")}
    </p>
    <Gap height="6rem" />

    <div class="topics">
        <div class="content-box">
            <Subline>
                <IconImg svg={KrankenwagenIcon} color="var(--yellow)" />
                &nbsp;
                {@html $t("page.digitalalarm.box.1.headline")}
            </Subline>
            <p>
                {@html $t("page.digitalalarm.box.1.p")}
            </p>
        </div>

        <div class="content-box">
            <Subline>
                <IconImg svg={AlarmIcon} color="var(--yellow)" />
                &nbsp;
                {@html $t("page.digitalalarm.box.2.headline")}
            </Subline>
            <p>
                {@html $t("page.digitalalarm.box.2.p.1")}
            </p>
            <p>
                {@html $t("page.digitalalarm.box.2.p.2")}
            </p>
        </div>
    </div>
</Container>

<Container>
    <Gap big />
    <ProjectPreviews
        data_callback={loadData}
        url_base="projekte"
        show_empty_message={false}
    />
</Container>

<Container big>
    <PagePreviews leitstellen wachen_elw sprach_datenfunk />
</Container>

<center>
    <Btn arrow href="kontakt">
        {@html $t("page.digitalalarm.btn.projectrequest")}
    </Btn>
</center>

<!-- <ButtonRow>
    <Btn yellow href="./ueber-uns/unsere-werte">Mehr über uns</Btn>
    <Btn href="./aktuelles/news">Aktuelles</Btn>
</ButtonRow> -->
<style lang="scss">
    @import "../../vars.scss";

    .topics {
        display: grid;
        grid-template-columns: repeat(12, 1fr);
        gap: 2rem;
        > * {
            grid-column: span 6;
            @media (max-width: 800px) {
                grid-column: span 12;
            }
        }
        :nth-child(3n) {
            grid-column: 1/-1 !important;
        }
    }
    .content-box {
        padding: 2rem;
        border-radius: 2rem;
        transition: 0.1s;
        border: 2px solid $grayDark2;
        &:hover {
            border: 2px solid $yellow;
            // background-color: $grayDark2;
            // box-shadow: 0 0 0.25em 0.25em $yellow;
        }
        :global(body.light) & {
            background-color: $grayLight2;
            :global(*) {
                color: $grayDark;
            }
        }
    }
</style>
